import { useState, useEffect, useRef } from 'react'; 
import { FiLogOut } from 'react-icons/fi'; // Using react-icons for the logout icon
import { FaUser, FaCreditCard, FaHistory, FaCog, FaHome, FaQrcode, FaShoppingCart, FaEllipsisV } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import {endpoint} from "./endpoint";
const AppHeader = () => {
    const [currentDate, setCurrentDate] = useState('');
    const [showMenu, setShowMenu] = useState(false);
    const navigate = useNavigate();
    const menuRef = useRef(null);
    const menuButton = useRef(null);

    const toggleMenu = () => {
        setShowMenu(prevState => !prevState);
    };

    useEffect(() => {
        const date = new Date();
        setCurrentDate(date.toLocaleDateString(undefined, { 
            weekday: 'long', 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
        }));
    }, []);

    const logout = async () => {
        const token = localStorage.getItem('authToken');

        if (!token) {
            navigate('/login');
            return;
        }

        try {
            const response = await fetch(`${endpoint}/gymapp/logout.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ token })
            });

            const data = await response.json();

            if (data.status === 'success') {
                // Remove token from localStorage
                localStorage.clear();
                navigate('/login');
            } else {
                localStorage.clear();
                navigate('/login');
            }
        } catch (error) {
            console.error('Error logging out:', error);
        }
    };

    return (
        <>
            <div
                style={{
                    top: "0px",
                    left: "0px",
                    position: "fixed",
                    width: "100vw",
                    zIndex: "8",
                    background: "white",
                    height: "65px",
                    borderBottom: "1px solid #ccc",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "0 15px",
                }}
            >
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <span style={{ fontSize: "12px", color: "#666" }}>{currentDate}</span>
                    <span style={{ fontSize: "18px", fontWeight: "bold" }}>Active Rinse</span>
                </div>
                <FaUser onClick={toggleMenu} size={24} style={{ cursor: "pointer", color: "#333" }} />
            </div>
            {/* Dropdown Menu */}
            {showMenu && (
                <div ref={menuRef} onClick={toggleMenu} className="bg-white border rounded p-2 shadow" style={{ top: '60px', position: "fixed", right: '15px', width: '250px', zIndex: '9999' }}>
                    <div className="dropdown-item d-flex align-items-center" onClick={() => navigate('/profile')}>
                        <FaUser size={18} className="me-2" />
                        <span>Profile</span>
                    </div>
                    <div className="dropdown-item d-flex align-items-center" onClick={() => navigate('/order')}>
                        <FaCreditCard size={18} className="me-2" />
                        <span>Pay for a collection</span>
                    </div>
                    <div className="dropdown-item d-flex align-items-center" onClick={() => navigate('/scan')}>
                        <FaQrcode size={18} className="me-2" />
                        <span>QR Code</span>
                    </div>
                    <div className="dropdown-item d-flex align-items-center" onClick={logout}>
                        <FiLogOut size={18} className="me-2" />
                        <span>Logout</span>
                    </div>
                </div>
            )}
        </>
    );
};

export default AppHeader;
